<template>
  <section class='leaveStu'>
    <Row>
      <Breadcrumb>
        <BreadcrumbItem>媒体发布</BreadcrumbItem>
        <BreadcrumbItem>栏目设置</BreadcrumbItem>
      </Breadcrumb>
    </Row>
    <Row xs="20" sm="16" md="12" lg="8">



      <Row id='pdData' class='pdData'>
        <div :class='[0 == curIndex ? "active" : ""]' class='itempd' @click='tabPD("news")'>新闻</div>
        <!-- <div :class='[1 == curIndex ? "active" : ""]'  class='itempd' @click='tabPD("paike")'>拍客</div> -->

      </Row>
      <i-button type="error" @click='sModal(-1)' style="position:absolute;right:0px;top:0px;">新增栏目</i-button>
    </Row>
    <section class='tabelContent'>
      <tablePage border :queryData="queryData" :searchParam='searchParam' :issearch='issearch' @smodal='sModal'>
      </tablePage>
    </section>


    <bemodal :reloadtmp='reloadTmep' :formdata='formData' @reloadModalData='reloadTable'></bemodal>
  </section>
</template>

<script>
import getDates from '../utils/index'
import tablePage from './tablePage'
import bemodal from './formItemNoSch'
export default {
  name: 'newslist',
  components: {
    tablePage,
    bemodal,
  },
  data () {
    return {
      curIndex: 0,
      smodal: false,
      reloadTmep: -1,
      initpk: [],
      pk: [
        ['dic/getId', 'dic/save', 'dic/delete'],
        [
          {
            type: 'input',
            title: '栏目名称',
            name: 'name',
            model: '',
            block: true,
          },
          {
            type: 'numberInput',
            // type: 'input',
            title: '移动端排序',
            name: 'sort',
            model: 1,
            block: true,
          },
          {
            type: 'numberInput',
            // type: 'input',
            title: '电脑端排序',
            name: 'pcsort',
            model: 1,
            block: true,
          },
          {
            type: 'textarea',
            title: '备注',
            name: 'remark',
            model: ''
          },

          {
            type: 'hidden',
            children: [{
              name: 'guid',
              model: ''
            }, {
              name: 'rootid',
              model: 'paike'
            }]
          }
        ]
      ],
      initformData: [],
      formData: [
        ['dic/getId', 'dic/save', 'dic/delete'],
        [
          {
            type: 'input',
            title: '栏目名称',
            name: 'name',
            model: '',
            block: true,
          },
          {
            type: 'numberInput',
            // type: 'input',
            title: '手机端排序',
            name: 'sort',
            model: 1,
            block: true,
          },
          {
            type: 'numberInput',
            // type: 'input',
            title: '电脑端排序',
            name: 'pcsort',
            model: 1,
            block: true,
          },
          {
            type: 'checkbox',
            title: '栏目所属',
            name: 'url',
            model: '',
            children: [
              { model: false, name: 'isapp', title: '小程序' },
              { model: false, name: 'isweb', title: '新闻网' }
            ],
            block: true,

          },
          {
            type: 'input',
            title: '超链接',
            name: 'url',
            model: '',

          },
          {
            type: 'textarea',
            title: '备注',
            name: 'remark',
            model: ''
          },

          {
            type: 'hidden',
            children: [{
              name: 'guid',
              model: ''
            }, {
              name: 'rootid',
              model: 'news'
            }]
          }
        ]
      ],
      queryData: ['dic/getQueryList?rootid=news&pid=0',
        [
          {
            title: '栏目名称',
            key: 'name',
            width: 150,
            align: 'center',
            render: (h, params) => {
              return h('span', decodeURI(params.row.name))
            }
          },
          {
            title: '栏目所属',
            key: '',
            width: 120,
            align: 'center',
            render: (h, params) => {

              var isapp = params.row.isapp
              var isweb = params.row.isweb

              var isppicon = h('icon', {
                props: {
                  type: "md-phone-portrait",
                  size: '15'
                },

              })
              var iswebicon = h('icon', {
                props: {
                  type: "md-desktop",
                  size: '15'
                },
              })
              if (isapp == 1 && isweb == 1) {
                return h('div', [isppicon, iswebicon])
              } else if (isapp == 1 && isweb == 0) {
                return h('div', [isppicon])
              } else if (isapp == 0 && isweb == 1) {
                return h('div', [iswebicon])
              } else {
                return h('div', [])
              }
            }
          },

          {
            title: '电脑端排序',
            key: 'pcsort',
            width: 150,
            align: 'center',
          },
          {
            title: '手机端排序',
            key: 'sort',
            width: 150,
            align: 'center',
          },
          {
            title: '链接地址',
            key: 'url',
          },
          {
            title: '操作',
            slot: 'action',
            width: 100,
            align: 'center',
            // render: (h, params) => {
            //   return h('div', [
            //     h('span', {
            //       style: {
            //         display: 'inline-block',
            //         width: '60px',
            //         height: '25px',
            //         background: '#2db7f5',
            //         borderRadius: '6px',
            //         textAlign: 'center',
            //         lineHeight: '25px',
            //         color: '#fff',
            //         fontSize: '12px',
            //         cursor: 'pointer',
            //         userSelect: 'none'
            //       },
            //       on: {
            //         click: () => {

            // 		  this.$router.push('/db')



            //         }
            //       }
            //     }, '编辑')
            //   ])

            // }
          }

        ]
      ],
      searchParam: {
        name: '',
      },
      issearch: -1,
    }
  },
  mounted () {
    this.initformData = JSON.parse(JSON.stringify(this.formData[1]))
    this.initpk = JSON.parse(JSON.stringify(this.pk[1]))
  },
  methods: {
    tabPD (type) {
      console.log(type)

      var that = this
      if (type == 'news') {
        that.curIndex = 0
        this.queryData[0] = 'dic/getQueryList?rootid=news&pid=0'
      } else if (type == 'paike') {
        that.curIndex = 1
        this.queryData[0] = 'dic/getQueryList?rootid=paike&pid=0'
      }
      this.searchData()
    },
    searchData () {
      this.issearch = Math.random()
    },
    sModal (guid) {
      console.log(this.curIndex)
      if (this.curIndex == 0) {
        if (this.formData[0][0].indexOf('?') > -1) {
          this.formData[0][0] = this.formData[0][0].split('?')[0]
        }
        this.formData[0][0] = this.formData[0][0] + '?id=' + guid

        this.formData[1] = JSON.parse(JSON.stringify(this.initformData))

      } else {
        if (this.formData[0][0].indexOf('?') > -1) {
          this.formData[0][0] = this.pk[0][0].split('?')[0]
        }
        this.formData[0][0] = this.pk[0][0] + '?id=' + guid

        this.formData[1] = JSON.parse(JSON.stringify(this.initpk))

      }
      console.log(this.formData[1])
      this.reloadTmep = Math.random()
    },
    reloadTable () {
      this.issearch = Math.random()
    }
  }
}
</script>

<style scoped>
.tabelContent {
  margin-top: 20px;
}

.leaveStu {
  flex: 1;
  padding-right: 25px !important;
  /* overflow: scroll; */
  padding-bottom: 50px;
  padding-top: 20px;
  overflow-x: hidden;
}

.leaveStu .ivu-row:first-of-type {
  margin-top: 5px;
}

.leaveStu .ivu-row {
  margin-top: 20px;
  /* 	overflow:hidden; */
  position: relative;
}

.leaveStu .ivu-col {
  margin-right: 10px;
  /* float:left; */
}

.leaveStu .ivu-col:last-of-type {
  float: left;
  margin-left: 10px;
  /* position:absolute;
		right:0px; */
}

.demo-upload-list {



  border: 1px solid transparent;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  position: relative;
  overflow: hidden;
  margin-right: 4px;
  margin-bottom: 5px;
}

.demo-upload-list img {
  width: 40px;
  height: 40px;
  float: left;
  margin-right: 15px;
}

.demo-upload-list span {
  line-height: 40px;
  font-size: 12px;
  float: left;
}

.demo-upload-list-cover {
  display: none;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, .6);
}

.demo-upload-list:hover .demo-upload-list-cover {
  display: block;
}

.demo-upload-list-cover i {
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  margin: 0 10px;
  line-height: 40px;

}

#hwSchool {
  position: relative;
}

#hwSchool .ivu-tree {
  position: absolute;
  top: 33px;
  left: 0px;
  background: #fff;
  z-index: 1000;
  width: 300px;
  height: 300px;
  border: 1px solid #dcdee2;
  border-top: 0 none;
  overflow-y: scroll;
  overflow-x: hidden;
  padding-left: 10px;
}

.modalUl {
  width: 100%;
  display: flex;
  justify-content: space-between;


}

.modalUl li {
  list-style: none;

}

.modalUl>li:first-of-type {
  width: 35%;
  height: 100%;
  height: 400px;
  overflow-y: scroll;
  overflow-x: hidden;
}

.modalUl>li:last-of-type {
  flex: 1;
  padding-left: 30px;
}

.treeContent {}

.hwImgCon {
  margin-top: 10px;

}

.hwImgCon img {
  width: 55px;
  height: 55px;
  border-radius: 5px;
}

.conheadRight {
  float: right;
}

.pdData {
  display: flex;
  justify-content: flex-start;
  list-style: none;
  flex-wrap: wrap;
}

.itempd {
  height: 32px;
  line-height: 32px;
  border-radius: 20px;
  padding: 0 15px;
  font-size: 14px;
  margin-right: 10px;
  cursor: pointer
}

.itempd.active {
  background-color: #00d186;
  border-color: #00d186;
  color: #fff;
}
</style>
